import { render, staticRenderFns } from "./GroupsV2.vue?vue&type=template&id=4f20e668&scoped=true"
import script from "./GroupsV2.vue?vue&type=script&lang=js"
export * from "./GroupsV2.vue?vue&type=script&lang=js"
import style0 from "./GroupsV2.vue?vue&type=style&index=0&id=4f20e668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f20e668",
  null
  
)

export default component.exports